export type ParsedLogCommit = {
  sha: string;
  shortSha: string;
  subject: string;
  committedAt: string;
};

/** Parse `git log --format=%H\\t%cI\\t%s` lines. */
export function parseLogShaDateSubjectLines(raw: string): ParsedLogCommit[] {
  const out: ParsedLogCommit[] = [];
  for (const line of String(raw).split('\n')) {
    const l = line.trimEnd();
    if (!l.trim()) continue;
    const parts = l.split('\t');
    if (parts.length < 3) continue;
    const sha = parts[0].trim();
    const committedAt = parts[1].trim();
    const subject = parts.slice(2).join('\t').trim();
    if (!/^[0-9a-f]{7,40}$/i.test(sha)) continue;
    out.push({ sha, shortSha: sha.slice(0, 7), subject, committedAt });
  }
  return out;
}
